import { get } from "svelte/store"
import { apiBaseOverride } from "../../../_shared/_logic/store"
import { type WorkOrderStatus } from "../../../_shared/_logic/enums"
import { baseAPIURL } from "../../_shared/_logic/config"
import { ApiError } from "../presentation"
import { parseApiErrorPayload, resolveApiErrorMessage } from "../../error-message"

export type PublicProperty = {
  id: string
  street: string
  house_number: string | null
  zip: string | null
  city: string | null
  country: string | null
  address_extra: string | null
}

export type PublicWorkOrder = {
  id: string
  organization_id: string
  organization_name: string
  organization_slug: string
  order_number: string | null
  order_type_public_label: string | null
  order_type_public_labels?: string[]
  order_type_description: string | null
  status: WorkOrderStatus
  due_date: string | null
  estimated_duration_min: number | null
  property: PublicProperty
}

const BASE_PATH = "/public/work-orders"

const resolveBaseUrl = () => {
  const override = get(apiBaseOverride)

  return override ?? baseAPIURL
}

const joinUrl = (path: string) => {
  const base = resolveBaseUrl().replace(/\/+$/, "")
  const normalized = path.startsWith("/") ? path : `/${path}`

  return `${base}${normalized}`
}

export const fetchPublicWorkOrder = async (orderId: string) => {
  const target = orderId?.trim()

  if (!target) {
    throw new ApiError(400, "Ungültiger Auftrag.")
  }

  const response = await fetch(joinUrl(`${BASE_PATH}/${encodeURIComponent(target)}`))

  if (!response.ok) {
    const { detail } = await parseApiErrorPayload(response)
    const message = resolveApiErrorMessage(detail, {
      statusCode: response.status,
      statusText: response.statusText,
    })
    throw new ApiError(response.status, message, detail)
  }

  return (await response.json()) as PublicWorkOrder
}
